import { Trash2, FileDown } from "lucide-react";
import { downloadFile } from "@/lib/api";
import { toast } from "sonner";

const STATUS_TONE = { completed: "text-emerald-400", failed: "text-red-400" };
const statusClass = (s) => STATUS_TONE[s] || "text-amber-400";

// One-page Addendum Impact Report download (addendum reviews only).
export const ImpactReportButton = ({ runId, className = "" }) => {
  const dl = async () => {
    try { await downloadFile(`/reviews/${runId}/impact-report?format=pdf`, `Addendum-Impact-${runId.slice(0, 8)}.pdf`); toast.success("Addendum Impact Report downloaded"); }
    catch (e) { toast.error(e?.message || "Could not build the impact report"); }
  };
  return <button onClick={dl} className={`inline-flex items-center gap-1 text-amber-400 hover:text-amber-300 ${className}`} title="One-page Addendum Impact Report (PDF)" data-testid={`impact-report-${runId}`}><FileDown className="w-3.5 h-3.5" /> Impact report</button>;
};

export function ReviewHistory({ runs, can, onDelete }) {
  return (
    <div className="sc-card p-6 lg:col-span-4">
      <div className="label-cap mb-3">Review History</div>
      <div className="space-y-2 max-h-96 overflow-y-auto">
        {runs.map((r) => (
          <div key={r.id} className="border border-slate-800 rounded-md p-3 text-xs" data-testid={`run-row-${r.id}`}>
            <div className="flex justify-between items-center gap-2">
              <span className="font-semibold text-slate-100 capitalize">{r.mode.replace(/_/g, " ")}</span>
              <span className="flex items-center gap-2">
                <span className={`px-1.5 rounded font-mono ${statusClass(r.status)}`}>{r.status}</span>
                {can("edit") && <button onClick={() => onDelete({ type: "run", id: r.id, label: `this ${r.mode.replace(/_/g, " ")} review and its ${r.finding_count ?? 0} findings` })} className="text-slate-500 hover:text-red-400" data-testid={`delete-run-${r.id}`}><Trash2 className="w-3.5 h-3.5" /></button>}
              </span>
            </div>
            <div className="text-slate-500 font-mono mt-1">{new Date(r.created_at).toLocaleString()}</div>
            <div className="text-slate-400 mt-1 flex items-center justify-between gap-2"><span>{r.finding_count ?? 0} findings · {r.model_provider}</span>
              {r.mode === "addendum_review" && r.status === "completed" && <ImpactReportButton runId={r.id} />}</div>
          </div>
        ))}
        {!runs.length && <div className="text-sm text-slate-500">No reviews yet.</div>}
      </div>
    </div>
  );
}
